import "../../Styles/Sponsor/SponsorS.css"
import ZGA from "../../Assets/ZGA.png";

const SponsorS = () => {
  return (
    <div className="sponsorS">
      <div>
        <h1>Sponsor a student</h1>
        <p>
          Your support can transform the life of a student, giving her the opportunity to gain Islamic knowledge and
          build a future grounded in faith. Allah (SWT) says in the Qur'an: "And whatever you spend in good, it will be
          fully repaid to you, and you will not be wronged." (Surah Al-Baqarah 2:272). Sponsor a student today and make
          a lasting impact on her education and future, while earning continuous rewards from Allah.
        </p>
      </div>
      <div>
        <h3>Our sponsorship packages</h3>
        <div>
          <div className="package">
            <img src={ZGA} alt="The Zulaykha Global Academy" />
            <span>SPONSOR ONE STUDENT</span>
            <a href="https://wa.link/u7w666">Sponsor</a>
          </div>
          <div className="package">
            <img src={ZGA} alt="The Zulaykha Global Academy" />
            <span>SPONSOR THREE OR MORE STUDENTS</span>
            <a href="https://wa.link/u7w666">Sponsor</a>
          </div>
          <div className="package">
            <img src={ZGA} alt="The Zulaykha Global Academy" />
            <span>SPONSOR TWO STUDENTS</span>
            <a href="https://wa.link/u7w666">Sponsor</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SponsorS;
